import moment from 'moment/moment'

export function countNonBusinessDaysAndDuration(
  minDateStr: Date,
  maxDateStr: Date,
  holidaysData: {
    start: string
    end: string
  }[],
) {
  let nonBusinessDays = 0
  let durationHours = moment(maxDateStr).diff(moment(minDateStr), 'hours') + 24 // include maxDate full day

  const minDate = moment(minDateStr)
  const maxDate = moment(maxDateStr)

  for (let date = moment(minDate); date.isSameOrBefore(maxDate); date.add(1, 'days')) {
    if (date.day() !== 0) {
      nonBusinessDays++
      durationHours -= 24
    }

    if (
      holidaysData?.some(holiday => {
        const holidayStart = moment(holiday.start, 'YYYY-MM-DDTHH:mm:ss')
        const holidayEnd = moment(holiday.end, 'YYYY-MM-DDTHH:mm:ss')
        return date.isBetween(holidayStart, holidayEnd, 'day', '[]')
      })
    ) {
      nonBusinessDays++
      durationHours -= 24
    }
  }

  return { nonBusinessDays, durationHours }
}
